module.exports = __webpack_public_path__ + "img/subscriptions_white_48dp.952cb692.svg";